var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "col-12 col-lg-3 col-xl-3 col-md-3 d-flex align-items-center d-md-block d-xl-block d-lg-block"
    },
    [
      _c("button", {
        staticClass: "btn btn-back d-block d-xl-none d-md-none d-lg-none",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.$router.push("/jobs")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-column flex-lg-row flex-xl-row flex-md-row" },
        [
          _c("button", {
            staticClass: "btn btn-back d-none d-xl-block d-md-block d-lg-block",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$router.push("/jobs")
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "d-flex refId pr-1" }, [
            _vm.isFlatRate
              ? _c("img", {
                  staticClass: "flat-rate-indicator pr-1",
                  attrs: {
                    src: require("../../assets/img/flat-rate-job-icon.svg"),
                    alt: "Flat rate job icon"
                  }
                })
              : _vm._e(),
            _vm._v("\n      " + _vm._s(_vm.refId) + "\n    ")
          ]),
          _vm._v(" "),
          _vm.status
            ? _c("div", [
                _vm.status.name === "Accepted"
                  ? _c("span", { class: "btn-status btn-active" }, [
                      _vm._v(_vm._s(_vm.status.name))
                    ])
                  : _vm.status.name === "On Hold"
                    ? _c("span", { class: "btn-status btn-rejected" }, [
                        _vm._v(_vm._s(_vm.status.name))
                      ])
                    : _vm.status.name === "Pending"
                      ? _c("span", { class: "btn-status btn-pending" }, [
                          _vm._v(_vm._s(_vm.status.name))
                        ])
                      : _vm.status.name === "Created"
                        ? _c("span", { class: "btn-status btn-created" }, [
                            _vm._v(_vm._s(_vm.status.name))
                          ])
                        : _vm.status.name === "Canceled"
                          ? _c("span", { class: "btn-status btn-cancelled" }, [
                              _vm._v(_vm._s(_vm.status.name))
                            ])
                          : _vm.status.name === "In Progress"
                            ? _c(
                                "span",
                                { class: "btn-status btn-inprogress" },
                                [_vm._v(_vm._s(_vm.status.name))]
                              )
                            : _vm.status.name === "Tracking done"
                              ? _c(
                                  "span",
                                  { class: "btn-status btn-inprogress" },
                                  [_vm._v(_vm._s(_vm.status.name))]
                                )
                              : _vm.status.name === "Collect payment"
                                ? _c(
                                    "span",
                                    { class: "btn-status btn-inprogress" },
                                    [_vm._v(_vm._s(_vm.status.name))]
                                  )
                                : _vm.status.name === "Completed"
                                  ? _c(
                                      "span",
                                      { class: "btn-status btn-completed" },
                                      [_vm._v(_vm._s(_vm.status.name))]
                                    )
                                  : _vm.status.name === "Rejected"
                                    ? _c(
                                        "span",
                                        { class: "btn-status btn-rejected" },
                                        [_vm._v(_vm._s(_vm.status.name))]
                                      )
                                    : _c(
                                        "span",
                                        { class: "btn-status btn-inprogress" },
                                        [_vm._v(_vm._s(_vm.status.name))]
                                      )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "header-source d-none d-lg-block d-xl-block d-md-block"
        },
        [
          _vm._v("\n    " + _vm._s(_vm.source && _vm.source.name) + "\n    "),
          _vm.leadSource.name
            ? _c("span", { staticClass: "disabled" }, [
                _vm._v("(" + _vm._s(_vm.leadSource.name) + ")")
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5775ca86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5775ca86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobStatus.vue
// module id = null
// module chunks = 